// source: videostory/render_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_api_annotations_pb = require('../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.Credits', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.EstimateBasis', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.KnownDefect', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.PreviewFrom', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.QualityMode', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.Render', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderAssets', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderCheck', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderCheckOutcome', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderCost', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderDocument', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.SourceCase', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderFailure', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderFinished', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderNotify', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderProgress', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderStage', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderState', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderTimings', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.RenderTrigger', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.SecondsRange', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.oneofGroups_);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderDocument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderDocument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderAssets, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderAssets';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderNotify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderNotify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.Render = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.videostory.Render.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.Render, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.Render.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.Render';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.KnownDefect, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.KnownDefect';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderFinished, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderFinished';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderTimings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderTimings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderProgress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderCost, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderCost.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderCost';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderCheck, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderCheck';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderFailure, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderFailure';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.SecondsRange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.SecondsRange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.displayName = 'proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.SourceCase = {
  SOURCE_NOT_SET: 0,
  CONTENT: 1,
  URI: 2
};

/**
 * @return {proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.SourceCase}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.getSourceCase = function() {
  return /** @type {proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.SourceCase} */(jspb.Message.computeOneofCase(this, proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.toObject = function(includeInstance, msg) {
  var f, obj = {
content: (f = msg.getContent()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
uri: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDocument}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderDocument;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDocument}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional google.protobuf.Struct content = 1;
 * @return {?proto.google.protobuf.Struct}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.getContent = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 1));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.setContent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.hasContent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string uri = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.getUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.setUri = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.clearUri = function() {
  return jspb.Message.setOneofField(this, 2, proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.prototype.hasUri = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderAssets} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.toObject = function(includeInstance, msg) {
  var f, obj = {
folderUri: jspb.Message.getFieldWithDefault(msg, 1, ""),
filesMap: (f = msg.getFilesMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderAssets}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderAssets;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderAssets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderAssets}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderUri(value);
      break;
    case 2:
      var value = msg.getFilesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderAssets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderUri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFilesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string folder_uri = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.prototype.getFolderUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderAssets} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.prototype.setFolderUri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * map<string, string> files = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.prototype.getFilesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderAssets} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.prototype.clearFilesMap = function() {
  this.getFilesMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.toObject = function(includeInstance, msg) {
  var f, obj = {
githubIssue: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderNotify}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderNotify;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderNotify}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGithubIssue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGithubIssue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string github_issue = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.prototype.getGithubIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderNotify} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.prototype.setGithubIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
videoId: jspb.Message.getFieldWithDefault(msg, 1, ""),
shootingScript: (f = msg.getShootingScript()) && proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.toObject(includeInstance, f),
dub: (f = msg.getDub()) && proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.toObject(includeInstance, f),
voiceCasting: (f = msg.getVoiceCasting()) && proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.toObject(includeInstance, f),
look: jspb.Message.getFieldWithDefault(msg, 5, ""),
deliverable: jspb.Message.getFieldWithDefault(msg, 6, ""),
story: (f = msg.getStory()) && proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.toObject(includeInstance, f),
assets: (f = msg.getAssets()) && proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.toObject(includeInstance, f),
narrationCache: jspb.Message.getFieldWithDefault(msg, 9, ""),
previewFrom: jspb.Message.getFieldWithDefault(msg, 10, 0),
output: jspb.Message.getFieldWithDefault(msg, 11, ""),
environment: jspb.Message.getFieldWithDefault(msg, 12, ""),
trigger: jspb.Message.getFieldWithDefault(msg, 13, 0),
tenant: jspb.Message.getFieldWithDefault(msg, 14, ""),
notify: (f = msg.getNotify()) && proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.toObject(includeInstance, f),
renderId: jspb.Message.getFieldWithDefault(msg, 16, ""),
validateOnly: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
maxCostUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
qualityMode: jspb.Message.getFieldWithDefault(msg, 19, 0),
credits: jspb.Message.getFieldWithDefault(msg, 20, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest;
  return proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoId(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderDocument;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.deserializeBinaryFromReader);
      msg.setShootingScript(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderDocument;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.deserializeBinaryFromReader);
      msg.setDub(value);
      break;
    case 4:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderDocument;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.deserializeBinaryFromReader);
      msg.setVoiceCasting(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLook(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeliverable(value);
      break;
    case 7:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderDocument;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.deserializeBinaryFromReader);
      msg.setStory(value);
      break;
    case 8:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderAssets;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.deserializeBinaryFromReader);
      msg.setAssets(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setNarrationCache(value);
      break;
    case 10:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.PreviewFrom} */ (reader.readEnum());
      msg.setPreviewFrom(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutput(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnvironment(value);
      break;
    case 13:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderTrigger} */ (reader.readEnum());
      msg.setTrigger(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenant(value);
      break;
    case 15:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderNotify;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.deserializeBinaryFromReader);
      msg.setNotify(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setRenderId(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValidateOnly(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxCostUsd(value);
      break;
    case 19:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.QualityMode} */ (reader.readEnum());
      msg.setQualityMode(value);
      break;
    case 20:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.Credits} */ (reader.readEnum());
      msg.setCredits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideoId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShootingScript();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.serializeBinaryToWriter
    );
  }
  f = message.getDub();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.serializeBinaryToWriter
    );
  }
  f = message.getVoiceCasting();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.serializeBinaryToWriter
    );
  }
  f = message.getLook();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDeliverable();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStory();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderDocument.serializeBinaryToWriter
    );
  }
  f = message.getAssets();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderAssets.serializeBinaryToWriter
    );
  }
  f = message.getNarrationCache();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPreviewFrom();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getOutput();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getEnvironment();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTrigger();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getTenant();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getNotify();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.serializeBinaryToWriter
    );
  }
  f = message.getRenderId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getValidateOnly();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getMaxCostUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getQualityMode();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getCredits();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
};


/**
 * optional string video_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getVideoId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setVideoId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RenderDocument shooting_script = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getShootingScript = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderDocument, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setShootingScript = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.clearShootingScript = function() {
  return this.setShootingScript(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.hasShootingScript = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RenderDocument dub = 3;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getDub = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderDocument, 3));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setDub = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.clearDub = function() {
  return this.setDub(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.hasDub = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RenderDocument voice_casting = 4;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getVoiceCasting = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderDocument, 4));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setVoiceCasting = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.clearVoiceCasting = function() {
  return this.setVoiceCasting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.hasVoiceCasting = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string look = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getLook = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setLook = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string deliverable = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getDeliverable = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setDeliverable = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional RenderDocument story = 7;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getStory = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderDocument, 7));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderDocument|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setStory = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.clearStory = function() {
  return this.setStory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.hasStory = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional RenderAssets assets = 8;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderAssets}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getAssets = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderAssets} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderAssets, 8));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderAssets|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setAssets = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.clearAssets = function() {
  return this.setAssets(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.hasAssets = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string narration_cache = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getNarrationCache = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setNarrationCache = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional PreviewFrom preview_from = 10;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.PreviewFrom}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getPreviewFrom = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.PreviewFrom} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.PreviewFrom} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setPreviewFrom = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string output = 11;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getOutput = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setOutput = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string environment = 12;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getEnvironment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setEnvironment = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional RenderTrigger trigger = 13;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderTrigger}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getTrigger = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderTrigger} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderTrigger} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setTrigger = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string tenant = 14;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getTenant = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setTenant = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional RenderNotify notify = 15;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderNotify}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getNotify = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderNotify} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderNotify, 15));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderNotify|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setNotify = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.clearNotify = function() {
  return this.setNotify(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.hasNotify = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string render_id = 16;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getRenderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setRenderId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional bool validate_only = 17;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getValidateOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setValidateOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional double max_cost_usd = 18;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getMaxCostUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setMaxCostUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional QualityMode quality_mode = 19;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.QualityMode}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getQualityMode = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.QualityMode} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.QualityMode} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setQualityMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional Credits credits = 20;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Credits}
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.getCredits = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.Credits} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.Credits} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.prototype.setCredits = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
renderId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest;
  return proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRenderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRenderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string render_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.prototype.getRenderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.GetRenderRequest.prototype.setRenderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
videoId: jspb.Message.getFieldWithDefault(msg, 1, ""),
environment: jspb.Message.getFieldWithDefault(msg, 2, ""),
state: jspb.Message.getFieldWithDefault(msg, 3, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
pageToken: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest;
  return proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnvironment(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVideoId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEnvironment();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPageToken();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string video_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.getVideoId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.setVideoId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string environment = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.getEnvironment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.setEnvironment = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RenderState state = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderState}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.getState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderState} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderState} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string page_token = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.getPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersRequest.prototype.setPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
rendersList: jspb.Message.toObjectList(msg.getRendersList(),
    proto.org.codetricks.construction.code.assistant.videostory.Render.toObject, includeInstance),
nextPageToken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse;
  return proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.Render;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.Render.deserializeBinaryFromReader);
      msg.addRenders(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextPageToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRendersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.Render.serializeBinaryToWriter
    );
  }
  f = message.getNextPageToken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated Render renders = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.videostory.Render>}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.prototype.getRendersList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.videostory.Render>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.Render, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.videostory.Render>} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.prototype.setRendersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.Render=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.prototype.addRenders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.videostory.Render, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.prototype.clearRendersList = function() {
  return this.setRendersList([]);
};


/**
 * optional string next_page_token = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.prototype.getNextPageToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.ListRendersResponse.prototype.setNextPageToken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
renderId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest;
  return proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRenderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRenderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string render_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.prototype.getRenderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.CancelRenderRequest.prototype.setRenderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
render: (f = msg.getRender()) && proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.toObject(includeInstance, f),
edlUri: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest;
  return proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.deserializeBinaryFromReader);
      msg.setRender(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEdlUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRender();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest.serializeBinaryToWriter
    );
  }
  f = message.getEdlUri();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional SubmitRenderRequest render = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest}
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.prototype.getRender = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.SubmitRenderRequest|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.prototype.setRender = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.prototype.clearRender = function() {
  return this.setRender(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.prototype.hasRender = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string edl_uri = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.prototype.getEdlUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateRenderRequest.prototype.setEdlUri = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.repeatedFields_ = [15,19,23];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.Render.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.Render} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.toObject = function(includeInstance, msg) {
  var f, obj = {
renderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
videoId: jspb.Message.getFieldWithDefault(msg, 2, ""),
state: jspb.Message.getFieldWithDefault(msg, 3, 0),
stateDetail: jspb.Message.getFieldWithDefault(msg, 4, ""),
environment: jspb.Message.getFieldWithDefault(msg, 5, ""),
trigger: jspb.Message.getFieldWithDefault(msg, 6, 0),
tenant: jspb.Message.getFieldWithDefault(msg, 7, ""),
submittedBy: jspb.Message.getFieldWithDefault(msg, 8, ""),
submitTime: (f = msg.getSubmitTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
finishTime: (f = msg.getFinishTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
previewFrom: jspb.Message.getFieldWithDefault(msg, 11, 0),
timings: (f = msg.getTimings()) && proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.toObject(includeInstance, f),
progress: (f = msg.getProgress()) && proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.toObject(includeInstance, f),
cost: (f = msg.getCost()) && proto.org.codetricks.construction.code.assistant.videostory.RenderCost.toObject(includeInstance, f),
checksList: jspb.Message.toObjectList(msg.getChecksList(),
    proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.toObject, includeInstance),
outputs: (f = msg.getOutputs()) && proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.toObject(includeInstance, f),
failure: (f = msg.getFailure()) && proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.toObject(includeInstance, f),
estimate: (f = msg.getEstimate()) && proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.toObject(includeInstance, f),
warningsList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
validateOnly: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
notify: (f = msg.getNotify()) && proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.toObject(includeInstance, f),
qualityMode: jspb.Message.getFieldWithDefault(msg, 22, 0),
knownDefectsList: jspb.Message.toObjectList(msg.getKnownDefectsList(),
    proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.toObject, includeInstance),
credits: jspb.Message.getFieldWithDefault(msg, 24, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.Render;
  return proto.org.codetricks.construction.code.assistant.videostory.Render.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.Render} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRenderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoId(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStateDetail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnvironment(value);
      break;
    case 6:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderTrigger} */ (reader.readEnum());
      msg.setTrigger(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenant(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubmittedBy(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSubmitTime(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinishTime(value);
      break;
    case 11:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.PreviewFrom} */ (reader.readEnum());
      msg.setPreviewFrom(value);
      break;
    case 12:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderTimings;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.deserializeBinaryFromReader);
      msg.setTimings(value);
      break;
    case 13:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderProgress;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.deserializeBinaryFromReader);
      msg.setProgress(value);
      break;
    case 14:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderCost;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderCost.deserializeBinaryFromReader);
      msg.setCost(value);
      break;
    case 15:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderCheck;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.deserializeBinaryFromReader);
      msg.addChecks(value);
      break;
    case 16:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.deserializeBinaryFromReader);
      msg.setOutputs(value);
      break;
    case 17:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderFailure;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.deserializeBinaryFromReader);
      msg.setFailure(value);
      break;
    case 18:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.deserializeBinaryFromReader);
      msg.setEstimate(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addWarnings(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValidateOnly(value);
      break;
    case 21:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderNotify;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.deserializeBinaryFromReader);
      msg.setNotify(value);
      break;
    case 22:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.QualityMode} */ (reader.readEnum());
      msg.setQualityMode(value);
      break;
    case 23:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.KnownDefect;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.deserializeBinaryFromReader);
      msg.addKnownDefects(value);
      break;
    case 24:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.Credits} */ (reader.readEnum());
      msg.setCredits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.Render.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.Render} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRenderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVideoId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStateDetail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEnvironment();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTrigger();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getTenant();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSubmittedBy();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSubmitTime();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinishTime();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPreviewFrom();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getTimings();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.serializeBinaryToWriter
    );
  }
  f = message.getProgress();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.serializeBinaryToWriter
    );
  }
  f = message.getCost();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderCost.serializeBinaryToWriter
    );
  }
  f = message.getChecksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.serializeBinaryToWriter
    );
  }
  f = message.getOutputs();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.serializeBinaryToWriter
    );
  }
  f = message.getFailure();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.serializeBinaryToWriter
    );
  }
  f = message.getEstimate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.serializeBinaryToWriter
    );
  }
  f = message.getWarningsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getValidateOnly();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getNotify();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderNotify.serializeBinaryToWriter
    );
  }
  f = message.getQualityMode();
  if (f !== 0.0) {
    writer.writeEnum(
      22,
      f
    );
  }
  f = message.getKnownDefectsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      23,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.serializeBinaryToWriter
    );
  }
  f = message.getCredits();
  if (f !== 0.0) {
    writer.writeEnum(
      24,
      f
    );
  }
};


/**
 * optional string render_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getRenderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setRenderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string video_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getVideoId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setVideoId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional RenderState state = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderState}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getState = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderState} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderState} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string state_detail = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getStateDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setStateDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string environment = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getEnvironment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setEnvironment = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional RenderTrigger trigger = 6;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderTrigger}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getTrigger = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderTrigger} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderTrigger} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setTrigger = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string tenant = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getTenant = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setTenant = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string submitted_by = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getSubmittedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setSubmittedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp submit_time = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getSubmitTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setSubmitTime = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearSubmitTime = function() {
  return this.setSubmitTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.hasSubmitTime = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp finish_time = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getFinishTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setFinishTime = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearFinishTime = function() {
  return this.setFinishTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.hasFinishTime = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional PreviewFrom preview_from = 11;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.PreviewFrom}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getPreviewFrom = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.PreviewFrom} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.PreviewFrom} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setPreviewFrom = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional RenderTimings timings = 12;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderTimings}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getTimings = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderTimings} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderTimings, 12));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderTimings|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setTimings = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearTimings = function() {
  return this.setTimings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.hasTimings = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional RenderProgress progress = 13;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderProgress}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getProgress = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderProgress} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderProgress, 13));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderProgress|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setProgress = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearProgress = function() {
  return this.setProgress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.hasProgress = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional RenderCost cost = 14;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderCost}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getCost = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderCost} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderCost, 14));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderCost|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setCost = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearCost = function() {
  return this.setCost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.hasCost = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * repeated RenderCheck checks = 15;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck>}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getChecksList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderCheck, 15));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck>} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setChecksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.addChecks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.org.codetricks.construction.code.assistant.videostory.RenderCheck, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearChecksList = function() {
  return this.setChecksList([]);
};


/**
 * optional RenderOutputs outputs = 16;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getOutputs = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs, 16));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setOutputs = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearOutputs = function() {
  return this.setOutputs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.hasOutputs = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional RenderFailure failure = 17;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderFailure}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getFailure = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderFailure} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderFailure, 17));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderFailure|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setFailure = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearFailure = function() {
  return this.setFailure(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.hasFailure = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional RenderEstimate estimate = 18;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getEstimate = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate, 18));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setEstimate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearEstimate = function() {
  return this.setEstimate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.hasEstimate = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * repeated string warnings = 19;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getWarningsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setWarningsList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.addWarnings = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearWarningsList = function() {
  return this.setWarningsList([]);
};


/**
 * optional bool validate_only = 20;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getValidateOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setValidateOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional RenderNotify notify = 21;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderNotify}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getNotify = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderNotify} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderNotify, 21));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderNotify|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setNotify = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearNotify = function() {
  return this.setNotify(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.hasNotify = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional QualityMode quality_mode = 22;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.QualityMode}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getQualityMode = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.QualityMode} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.QualityMode} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setQualityMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 22, value);
};


/**
 * repeated KnownDefect known_defects = 23;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect>}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getKnownDefectsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.KnownDefect, 23));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect>} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setKnownDefectsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 23, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.addKnownDefects = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 23, opt_value, proto.org.codetricks.construction.code.assistant.videostory.KnownDefect, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.clearKnownDefectsList = function() {
  return this.setKnownDefectsList([]);
};


/**
 * optional Credits credits = 24;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Credits}
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.getCredits = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.Credits} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.Credits} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.Render} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.Render.prototype.setCredits = function(value) {
  return jspb.Message.setProto3EnumField(this, 24, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.toObject = function(includeInstance, msg) {
  var f, obj = {
check: jspb.Message.getFieldWithDefault(msg, 1, ""),
item: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
atSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect}
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.KnownDefect;
  return proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect}
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheck(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setItem(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAtSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCheck();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getItem();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAtSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional string check = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.prototype.getCheck = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.prototype.setCheck = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string item = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.prototype.getItem = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.prototype.setItem = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double at_seconds = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.prototype.getAtSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.KnownDefect} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.KnownDefect.prototype.setAtSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderFinished} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.toObject = function(includeInstance, msg) {
  var f, obj = {
schema: jspb.Message.getFieldWithDefault(msg, 1, ""),
render: (f = msg.getRender()) && proto.org.codetricks.construction.code.assistant.videostory.Render.toObject(includeInstance, f),
recordedTime: (f = msg.getRecordedTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFinished}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderFinished;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderFinished} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFinished}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchema(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.Render;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.Render.deserializeBinaryFromReader);
      msg.setRender(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRecordedTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderFinished} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchema();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRender();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.Render.serializeBinaryToWriter
    );
  }
  f = message.getRecordedTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string schema = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.getSchema = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFinished} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.setSchema = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Render render = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.Render}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.getRender = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.Render} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.Render, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.Render|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFinished} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.setRender = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFinished} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.clearRender = function() {
  return this.setRender(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.hasRender = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp recorded_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.getRecordedTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFinished} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.setRecordedTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFinished} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.clearRecordedTime = function() {
  return this.setRecordedTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFinished.prototype.hasRecordedTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.toObject = function(includeInstance, msg) {
  var f, obj = {
waitingForMachineSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
compileSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
waitingForRenderMachinesSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
renderSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
joinSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
totalSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderTimings;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWaitingForMachineSeconds(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCompileSeconds(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWaitingForRenderMachinesSeconds(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRenderSeconds(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setJoinSeconds(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalSeconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWaitingForMachineSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getCompileSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getWaitingForRenderMachinesSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getRenderSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getJoinSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getTotalSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional double waiting_for_machine_seconds = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.getWaitingForMachineSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.setWaitingForMachineSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double compile_seconds = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.getCompileSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.setCompileSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double waiting_for_render_machines_seconds = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.getWaitingForRenderMachinesSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.setWaitingForRenderMachinesSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double render_seconds = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.getRenderSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.setRenderSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double join_seconds = 5;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.getJoinSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.setJoinSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double total_seconds = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.getTotalSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderTimings} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTimings.prototype.setTotalSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
tasksTotal: jspb.Message.getFieldWithDefault(msg, 1, 0),
tasksFinished: jspb.Message.getFieldWithDefault(msg, 2, 0),
tasksFailed: jspb.Message.getFieldWithDefault(msg, 3, 0),
chunks: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderProgress}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderProgress;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderProgress}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTasksTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTasksFinished(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTasksFailed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChunks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTasksTotal();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTasksFinished();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTasksFailed();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getChunks();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 tasks_total = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.prototype.getTasksTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderProgress} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.prototype.setTasksTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 tasks_finished = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.prototype.getTasksFinished = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderProgress} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.prototype.setTasksFinished = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 tasks_failed = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.prototype.getTasksFailed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderProgress} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.prototype.setTasksFailed = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 chunks = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.prototype.getChunks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderProgress} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderProgress.prototype.setChunks = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderCost.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderCost} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.toObject = function(includeInstance, msg) {
  var f, obj = {
computeUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
narrationUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
totalUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCost}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderCost;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderCost.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderCost} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCost}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setComputeUsd(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setNarrationUsd(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalUsd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderCost.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderCost} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComputeUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getNarrationUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTotalUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional double compute_usd = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.prototype.getComputeUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCost} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.prototype.setComputeUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double narration_usd = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.prototype.getNarrationUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCost} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.prototype.setNarrationUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double total_usd = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.prototype.getTotalUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCost} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCost.prototype.setTotalUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
passed: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
message: jspb.Message.getFieldWithDefault(msg, 3, ""),
outcome: jspb.Message.getFieldWithDefault(msg, 4, 0),
stage: jspb.Message.getFieldWithDefault(msg, 5, 0),
blocking: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
checked: jspb.Message.getFieldWithDefault(msg, 7, 0),
found: jspb.Message.getFieldWithDefault(msg, 8, 0),
seconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
reportUri: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderCheck;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPassed(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 4:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheckOutcome} */ (reader.readEnum());
      msg.setOutcome(value);
      break;
    case 5:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderStage} */ (reader.readEnum());
      msg.setStage(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlocking(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setChecked(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFound(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSeconds(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setReportUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPassed();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOutcome();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStage();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getBlocking();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getChecked();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getFound();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getReportUri();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool passed = 2;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.getPassed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.setPassed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional RenderCheckOutcome outcome = 4;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheckOutcome}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.getOutcome = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheckOutcome} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheckOutcome} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.setOutcome = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional RenderStage stage = 5;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderStage}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.getStage = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.RenderStage} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderStage} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.setStage = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional bool blocking = 6;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.getBlocking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.setBlocking = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional int32 checked = 7;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.getChecked = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.setChecked = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 found = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.getFound = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.setFound = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double seconds = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.getSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.setSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional string report_uri = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.getReportUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderCheck} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheck.prototype.setReportUri = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.toObject = function(includeInstance, msg) {
  var f, obj = {
folderUri: jspb.Message.getFieldWithDefault(msg, 1, ""),
videoUri: jspb.Message.getFieldWithDefault(msg, 2, ""),
previewUri: jspb.Message.getFieldWithDefault(msg, 3, ""),
manifestUri: jspb.Message.getFieldWithDefault(msg, 4, ""),
subtitlesUri: jspb.Message.getFieldWithDefault(msg, 5, ""),
transcriptUri: jspb.Message.getFieldWithDefault(msg, 6, ""),
folderLink: jspb.Message.getFieldWithDefault(msg, 7, ""),
videoLink: jspb.Message.getFieldWithDefault(msg, 8, ""),
previewLink: jspb.Message.getFieldWithDefault(msg, 9, ""),
manifestLink: jspb.Message.getFieldWithDefault(msg, 10, ""),
delivery: (f = msg.getDelivery()) && proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.toObject(includeInstance, f),
linksUri: jspb.Message.getFieldWithDefault(msg, 12, ""),
linksMarkdownUri: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderUri(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoUri(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviewUri(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setManifestUri(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitlesUri(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTranscriptUri(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderLink(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoLink(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviewLink(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setManifestLink(value);
      break;
    case 11:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.deserializeBinaryFromReader);
      msg.setDelivery(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinksUri(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinksMarkdownUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderUri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVideoUri();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPreviewUri();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getManifestUri();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubtitlesUri();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTranscriptUri();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFolderLink();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getVideoLink();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPreviewLink();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getManifestLink();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDelivery();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.serializeBinaryToWriter
    );
  }
  f = message.getLinksUri();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLinksMarkdownUri();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string folder_uri = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getFolderUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setFolderUri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string video_uri = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getVideoUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setVideoUri = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string preview_uri = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getPreviewUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setPreviewUri = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string manifest_uri = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getManifestUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setManifestUri = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subtitles_uri = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getSubtitlesUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setSubtitlesUri = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string transcript_uri = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getTranscriptUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setTranscriptUri = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string folder_link = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getFolderLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setFolderLink = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string video_link = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getVideoLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setVideoLink = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string preview_link = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getPreviewLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setPreviewLink = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string manifest_link = 10;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getManifestLink = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setManifestLink = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional RenderDelivery delivery = 11;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getDelivery = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery, 11));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setDelivery = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.clearDelivery = function() {
  return this.setDelivery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.hasDelivery = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string links_uri = 12;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getLinksUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setLinksUri = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string links_markdown_uri = 13;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.getLinksMarkdownUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderOutputs.prototype.setLinksMarkdownUri = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.toObject = function(includeInstance, msg) {
  var f, obj = {
folderUri: jspb.Message.getFieldWithDefault(msg, 1, ""),
videoUri: jspb.Message.getFieldWithDefault(msg, 2, ""),
subtitlesUri: jspb.Message.getFieldWithDefault(msg, 3, ""),
transcriptUri: jspb.Message.getFieldWithDefault(msg, 4, ""),
manifestUri: jspb.Message.getFieldWithDefault(msg, 5, ""),
screenplayUri: jspb.Message.getFieldWithDefault(msg, 6, ""),
narrationUri: jspb.Message.getFieldWithDefault(msg, 7, ""),
linksUri: jspb.Message.getFieldWithDefault(msg, 8, ""),
linksMarkdownUri: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderUri(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVideoUri(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubtitlesUri(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTranscriptUri(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setManifestUri(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setScreenplayUri(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNarrationUri(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinksUri(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinksMarkdownUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolderUri();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVideoUri();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubtitlesUri();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTranscriptUri();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getManifestUri();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getScreenplayUri();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNarrationUri();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLinksUri();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLinksMarkdownUri();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string folder_uri = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.getFolderUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.setFolderUri = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string video_uri = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.getVideoUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.setVideoUri = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subtitles_uri = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.getSubtitlesUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.setSubtitlesUri = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string transcript_uri = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.getTranscriptUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.setTranscriptUri = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string manifest_uri = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.getManifestUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.setManifestUri = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string screenplay_uri = 6;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.getScreenplayUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.setScreenplayUri = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string narration_uri = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.getNarrationUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.setNarrationUri = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string links_uri = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.getLinksUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.setLinksUri = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string links_markdown_uri = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.getLinksMarkdownUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderDelivery.prototype.setLinksMarkdownUri = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderFailure} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.toObject = function(includeInstance, msg) {
  var f, obj = {
stage: jspb.Message.getFieldWithDefault(msg, 1, ""),
message: jspb.Message.getFieldWithDefault(msg, 2, ""),
logUri: jspb.Message.getFieldWithDefault(msg, 3, ""),
check: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFailure}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderFailure;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderFailure} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFailure}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStage(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLogUri(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCheck(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderFailure} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLogUri();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCheck();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string stage = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.prototype.getStage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFailure} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.prototype.setStage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFailure} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string log_uri = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.prototype.getLogUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFailure} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.prototype.setLogUri = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string check = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.prototype.getCheck = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderFailure} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderFailure.prototype.setCheck = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.toObject = function(includeInstance, msg) {
  var f, obj = {
low: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
typical: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
high: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SecondsRange}
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.SecondsRange;
  return proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SecondsRange}
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLow(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTypical(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHigh(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLow();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getTypical();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getHigh();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional double low = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.prototype.getLow = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.prototype.setLow = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double typical = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.prototype.getTypical = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.prototype.setTypical = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double high = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.prototype.getHigh = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.prototype.setHigh = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.repeatedFields_ = [14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.toObject = function(includeInstance, msg) {
  var f, obj = {
basis: jspb.Message.getFieldWithDefault(msg, 1, 0),
videoSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
waitingForMachine: (f = msg.getWaitingForMachine()) && proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.toObject(includeInstance, f),
compile: (f = msg.getCompile()) && proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.toObject(includeInstance, f),
waitingForRenderMachines: (f = msg.getWaitingForRenderMachines()) && proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.toObject(includeInstance, f),
render: (f = msg.getRender()) && proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.toObject(includeInstance, f),
total: (f = msg.getTotal()) && proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.toObject(includeInstance, f),
renderTasks: jspb.Message.getFieldWithDefault(msg, 8, 0),
narrationClips: jspb.Message.getFieldWithDefault(msg, 9, 0),
narrationClipsToSynthesize: jspb.Message.getFieldWithDefault(msg, 10, 0),
computeUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
narrationUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
totalUsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
notesList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate;
  return proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.videostory.EstimateBasis} */ (reader.readEnum());
      msg.setBasis(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVideoSeconds(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.SecondsRange;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.deserializeBinaryFromReader);
      msg.setWaitingForMachine(value);
      break;
    case 4:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.SecondsRange;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.deserializeBinaryFromReader);
      msg.setCompile(value);
      break;
    case 5:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.SecondsRange;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.deserializeBinaryFromReader);
      msg.setWaitingForRenderMachines(value);
      break;
    case 6:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.SecondsRange;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.deserializeBinaryFromReader);
      msg.setRender(value);
      break;
    case 7:
      var value = new proto.org.codetricks.construction.code.assistant.videostory.SecondsRange;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.deserializeBinaryFromReader);
      msg.setTotal(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRenderTasks(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNarrationClips(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNarrationClipsToSynthesize(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setComputeUsd(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setNarrationUsd(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalUsd(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addNotes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBasis();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getVideoSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getWaitingForMachine();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.serializeBinaryToWriter
    );
  }
  f = message.getCompile();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.serializeBinaryToWriter
    );
  }
  f = message.getWaitingForRenderMachines();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.serializeBinaryToWriter
    );
  }
  f = message.getRender();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.org.codetricks.construction.code.assistant.videostory.SecondsRange.serializeBinaryToWriter
    );
  }
  f = message.getRenderTasks();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getNarrationClips();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getNarrationClipsToSynthesize();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getComputeUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getNarrationUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getTotalUsd();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
};


/**
 * optional EstimateBasis basis = 1;
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.EstimateBasis}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getBasis = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.videostory.EstimateBasis} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.videostory.EstimateBasis} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setBasis = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double video_seconds = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getVideoSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setVideoSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional SecondsRange waiting_for_machine = 3;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getWaitingForMachine = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.SecondsRange, 3));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setWaitingForMachine = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.clearWaitingForMachine = function() {
  return this.setWaitingForMachine(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.hasWaitingForMachine = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SecondsRange compile = 4;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getCompile = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.SecondsRange, 4));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setCompile = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.clearCompile = function() {
  return this.setCompile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.hasCompile = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional SecondsRange waiting_for_render_machines = 5;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getWaitingForRenderMachines = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.SecondsRange, 5));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setWaitingForRenderMachines = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.clearWaitingForRenderMachines = function() {
  return this.setWaitingForRenderMachines(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.hasWaitingForRenderMachines = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional SecondsRange render = 6;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getRender = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.SecondsRange, 6));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setRender = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.clearRender = function() {
  return this.setRender(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.hasRender = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional SecondsRange total = 7;
 * @return {?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getTotal = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.videostory.SecondsRange, 7));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.videostory.SecondsRange|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
*/
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setTotal = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.clearTotal = function() {
  return this.setTotal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.hasTotal = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int32 render_tasks = 8;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getRenderTasks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setRenderTasks = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 narration_clips = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getNarrationClips = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setNarrationClips = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 narration_clips_to_synthesize = 10;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getNarrationClipsToSynthesize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setNarrationClipsToSynthesize = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double compute_usd = 11;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getComputeUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setComputeUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double narration_usd = 12;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getNarrationUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setNarrationUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double total_usd = 13;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getTotalUsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setTotalUsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * repeated string notes = 14;
 * @return {!Array<string>}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.getNotesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.setNotesList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.addNotes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate} returns this
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderEstimate.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.PreviewFrom = {
  PREVIEW_FROM_UNSPECIFIED: 0,
  DRAWN_FRAMES: 1,
  FOUR_K_VIDEO: 2
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.QualityMode = {
  QUALITY_MODE_UNSPECIFIED: 0,
  FAST: 1,
  BALANCED: 2,
  THOROUGH: 3
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.Credits = {
  CREDITS_UNSPECIFIED: 0,
  WITH_CREDITS: 1,
  WITHOUT_CREDITS: 2
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderState = {
  RENDER_STATE_UNSPECIFIED: 0,
  WAITING_FOR_MACHINE: 1,
  COMPILING: 2,
  WAITING_FOR_RENDER_MACHINES: 3,
  RENDERING: 4,
  JOINING: 5,
  SUCCEEDED: 6,
  FAILED: 7,
  CANCELLED: 8
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderTrigger = {
  RENDER_TRIGGER_UNSPECIFIED: 0,
  EVALUATION: 1,
  QA: 2,
  PRODUCT: 3
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.EstimateBasis = {
  ESTIMATE_BASIS_UNSPECIFIED: 0,
  COMPILED_EDL: 1,
  NARRATION_TEXT: 2
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderCheckOutcome = {
  RENDER_CHECK_OUTCOME_UNSPECIFIED: 0,
  RENDER_CHECK_PASSED: 1,
  RENDER_CHECK_FAILED: 2,
  RENDER_CHECK_REPORTED: 3,
  RENDER_CHECK_NOT_CHECKED: 4
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.videostory.RenderStage = {
  RENDER_STAGE_UNSPECIFIED: 0,
  RENDER_STAGE_SUBMIT: 1,
  RENDER_STAGE_COMPILE: 2,
  RENDER_STAGE_RENDER: 3,
  RENDER_STAGE_JOIN: 4
};

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.videostory);
